// The portal's calls to /api/account/balance and /api/account/wallet-entries (features/billing):
// shapes from packages/contracts, the same the v3 API answers with.
import { BalanceResponse, WalletEntryListResponse, type WalletEntryKind } from "@kilat/contracts/wallet";
import { api } from "@/lib/api-client";

export const ENTRIES_PER_PAGE = 25;

/** What the history is narrowed to: a kind, and WIB calendar days, both ends inclusive. */
export type EntryFilters = { kind?: WalletEntryKind | undefined; from?: string | undefined; to?: string | undefined };

/** The list's query string, the page first and only the filters that are set. */
export function entriesSearch(page: number, perPage: number, { kind, from, to }: EntryFilters) {
  const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
  if (kind) params.set("kind", kind);
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  return params.toString();
}

export const getBalance = () => api.request("/api/account/balance", { schema: BalanceResponse });

export const listWalletEntries = (page: number, filters: EntryFilters) =>
  api.request(`/api/account/wallet-entries?${entriesSearch(page, ENTRIES_PER_PAGE, filters)}`, {
    schema: WalletEntryListResponse,
  });
